"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = void 0;
const tslib_1 = require("tslib");
const react_router_dom_v5_compat_1 = require("react-router-dom-v5-compat");
const react_core_1 = require("@patternfly/react-core");
const react_1 = tslib_1.__importDefault(require("react"));
const BackButton = ({ to, variant = 'secondary' }) => (react_1.default.createElement(react_router_dom_v5_compat_1.Link, { to: to },
    react_1.default.createElement(react_core_1.Button, { variant: variant }, "Back")));
exports.BackButton = BackButton;
//# sourceMappingURL=BackButton.js.map